import axios from 'axios';
import config from '../config';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';

let chargebeeLoadPromise = null;
const loadAndInitializeChargebee = async () => {
  if (!chargebeeLoadPromise) {
    chargebeeLoadPromise = Promise.resolve().then(
      () =>
        new Promise(resolve => {
          const script = document.createElement('script');
          script.src = 'https://js.chargebee.com/v2/chargebee.js';
          script.onload = () => {
            if (!window.Chargebee) return;

            resolve(
              window.Chargebee.init({
                site: process.env.REACT_APP_CHARGEBEE_SITE_NAME,
              }),
            );
          };

          document.head.appendChild(script);
        }),
    );
  }

  return chargebeeLoadPromise;
};

const useChargebee = () => {
  const { bundle, token } = useSelector(state => state.loginReducer);

  const clickCallback = useCallback(async () => {
    const chargebeeInstance = await loadAndInitializeChargebee();

    chargebeeInstance.setPortalSession(() =>
      axios({
        method: 'POST',
        url: `${config.host}/bundles/${bundle}/chargebee-portal-session`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(({ data }) => data),
    );

    const cbPortal = chargebeeInstance.createChargebeePortal();
    cbPortal.open();
  }, [bundle, token]);

  return {
    clickCallback,
  };
};

export default useChargebee;
